/**
 * Building Asset API functions.
 *
 * Maps to backend scenario-service endpoints:
 *   POST   /api/communities/:cid/buildings/:bid/assets          - Create building asset
 *   GET    /api/communities/:cid/buildings/:bid/assets          - List building assets
 *   PUT    /api/communities/:cid/buildings/:bid/assets/:aid     - Update building asset
 *   DELETE /api/communities/:cid/buildings/:bid/assets/:aid     - Delete building asset
 */

import client from './client';

/**
 * List all assets for a building.
 * @param {string} communityId - UUID
 * @param {string} buildingId - UUID (internal PK)
 * @returns {Promise<Array>}
 */
export const getBuildingAssets = async (communityId, buildingId) => {
  return client.get(
    `/api/communities/${communityId}/buildings/${buildingId}/assets`
  );
};

/**
 * Create a building asset.
 * Only one asset of each type is allowed per building.
 * @param {string} communityId - UUID
 * @param {string} buildingId - UUID
 * @param {Object} data - { asset_type, specs }
 * @returns {Promise<Object>} Created building asset
 */
export const createBuildingAsset = async (communityId, buildingId, data) => {
  return client.post(
    `/api/communities/${communityId}/buildings/${buildingId}/assets`,
    data
  );
};

/**
 * Update a building asset's specs.
 * @param {string} communityId - UUID
 * @param {string} buildingId - UUID
 * @param {string} assetId - UUID
 * @param {Object} data - { specs }
 * @returns {Promise<Object>} Updated building asset
 */
export const updateBuildingAsset = async (communityId, buildingId, assetId, data) => {
  return client.put(
    `/api/communities/${communityId}/buildings/${buildingId}/assets/${assetId}`,
    data
  );
};

/**
 * Delete a building asset.
 * @param {string} communityId - UUID
 * @param {string} buildingId - UUID
 * @param {string} assetId - UUID
 * @returns {Promise<void>}
 */
export const deleteBuildingAsset = async (communityId, buildingId, assetId) => {
  return client.delete(
    `/api/communities/${communityId}/buildings/${buildingId}/assets/${assetId}`
  );
};
